module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-5",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Commodore was still closeted with a hastily assembled committee of staff officers, arguing for an investigation by ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of the distress signals from Tanafjord. In the “Chessboard Counter” room, Clark found himself a lone voice, disregarded and even derided, as he argued against any diversion of the submarine from her mission.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He could not have explained to himself the reasons for his reluctance. The cleanly-shaven, smartly-uniformed young men who surrounded him under the huge Perspex map-board enraged him with their confidence, their boyish enthusiasm. It was their cheerful dismissal of any doubts on his part that had stung him to contempt and counter argument. He repeated himself again and again, and the baffled, kindly smiles and the frowns of dismissal greeted every statement he made. He knew it was the Commodore he needed to convince, yet he once more reiterated the central thrust of his argument in a snapping, irritated tone. He justified his own stubbornness by reminding himself that he was the Navy Department’s-America’s only and solely responsible representative.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Look, you guys—” Lips twisted in derision or disdain. “You already know her type, you might even verify which boat she is. Only ten percent of their ballistic subs are out of Murmansk at any one time. If she’s screaming for help, then there may be nothing left to investigate by the time ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("reaches the fjord.” He could see the disbelief opening on their faces, livid as blushes. It angered him. “Hell, why would she be in a fjord in shallow water with limited sea room if she was going to play rough? Use a nuke depth bomb on her—it might work out cheaper than sending in ‘Leopard’.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Really, Clark, you’re quite the hysterical virgin this morning,” Copeland remarked waspishly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Clark was about to answer when the door opened. He recognised Giles Pyott as soon as he entered the room. Pyott was in army uniform, and the Commodore, who entered behind Pyott, was also in uniform. A glassy, urbane, impenetrable officialdom had suddenly settled on the room, the kind of formality that the Pentagon or the Navy Department could never muster or imitate. Thank God, Clark added to his observation. Pyott, grey hair immaculate, part of his pressed, polished uniform, looked pleased and elated. Clark was again reminded of children and their haste to please or to upstage.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Shall I tell them, Commodore, or will you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Carry on, Colonel Pyott,” the Commodore demurred, a smile leaking into his face and warping the firm line of his lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Very well.” The two men had approached the group beneath the map. Pyott studied it theatrically, glanced at Clark and nodded to him, then spoke to the group of Royal Navy officers. His manner implied that Clark had left the room. “Gentlemen, it has been decided that ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("be ordered to proceed, with utmost caution and all practicable speed, to the area of Tanafjord.” A sigh of communal satisfaction, one or two murmurs of congratulation and pleasure; the empty compliments of sycophancy, they appeared to Clark. He was a man in a grey suit with a pocketful of unfamiliar and rather despised credit cards. Not a gentleman, they might have said of him. Worry twisted in his stomach again, and he knew he could not keep silent. “Yes, gentlemen,” Pyott—who was from some faceless and important MoD/NATO committee called StratAn—continued, “the first Sea Lord and the Chiefs of Staff assign the gravest import to this intrusion into NATO territorial waters—” Again, the murmur of support. “The government of Norway, when informed, officially requested our assistance. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will be instructed by yourselves to carry out a monitoring and surveillance action at the mouth of the Tanafjord.” He smiled, at once the headmaster with his junior staff. “I leave the form of the task orders and encoding to you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ll get on with it, Colonel,” Pearson, the communications officer, offered, wiping his spectacles. Without them for the moment, he seemed more to suit the dark uniform and the gold cuffs. Returning them to his aquiline nose, he became clerkish again.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Are you certain of all this, Pyott?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was as if Clark had cheered for an opposing team. Pyott turned a lordly glance to the American, who was as tall as he was and more muscular but who did not pose his figure in quite the same seignorial manner.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I beg your pardon, Captain Clark?” The mention of rank was a reminder of good manners and the proper forms of address. “I don’t quite catch the drift of your question.” Outsider, the tone cried. Buccaneer. Pyott took in, with a raking glance that went from face to feet and back again, the civilian clothes, the muscular chest and shoulders, the tanned, square features. Clark was evidently a pretender engaged in some dubious masquerade.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I asked if you were certain? Are their Lordships certain? Are the Chiefs of Staff certain? Is NATO certain?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The proper channels, the protocol, all have been observed, Captain Clark,” Pyott replied frostily.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What in hell do they think the Russians are up to in Tanafjord, with a ballistic missile boat?” Clark almost bellowed, goaded by the imperturbable arrogance and self-assurance of the army officer. Like a line of automatons, the operators in front of their screens and terminals snapped to attention in their seats. The group beneath the map seemed to move slightly away from him, as if he had begun to exude a powerful, offensive body odour. “You think they’re invading Norway, starting the next war?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I do not know,” Pyott said icily, his face chalk white. “I do not make assumptions, especially ones that might be dismissive and therefore comforting. That is why ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("must do our investigating for us. Your own Navy Department has been consulted and has agreed. Brussels is in agreement. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("You ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("are out of step, Clark.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("has ‘Leopard’ on board. Doesn’t that worry you?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That fact weighed heavily with everyone at the meeting, and with everyone consulted. It is to our inestimable advantage that ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is the submarine on station, so to speak—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Bullshit! Crap and bullshit, Pyott! You people—you want to play games; you want to ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("really ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("try out your shiny new toy. You want to walk close to the cliff. Now I understand—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Perhaps we could continue this conversation outside,” Pyott remarked through pressed, almost unmoving lips. His face was now livid with anger. The naval officers, including the commodore, had moved away from them, sensitive of the embarrassment they knew Pyott must be experiencing.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I wouldn’t want the time of day from you, Pyott. You’re an asshole. A pompous asshole, at that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Clark brushed past Pyott, who avoided him like an experienced matador. Clark had allowed the situation to escape him. He was angry with himself, angry that it was Pyott he resented more than Pyott’s suggestion concerning ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As he prepared to slam the door of the “Chessboard Counter” room behind him, he could hear Pyott already reiterating StratAn and NATO’s orders concerning ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to the assembled company. His voice was laconic, controlled, smooth as glass.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It enraged Clark, and he knew he had to talk to Kenneth Aubrey. Something in him, deep as a lust as yet unfocussed, knew that he had to stop this ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("adventure ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with “Leopard” and ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He slammed the door loudly behind him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Aubrey studied Hyde’s face. It was evident the man’s challenge with regard to the fact of Quin’s disappearance was intended to irritate and intended also to disguise the Australian’s own new doubts.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Aubrey smoothed the last, vestigial wings of grey hair above his ears, and leaned back in his chair. Shelley, his aide, watched Hyde from the tall windows of the office in Queen Anne’s Gate.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re not sure now, are you?” Hyde repeated.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Don’t jump to conclusions,” Aubrey remarked severely. “What you saw was the girl. We know that she is unreliable, something of a failure, a drop-out. Is there any real reason to suppose that she knows where her father is? She wasn’t just trying to keep her mother calm?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The KGB chased her to the bus stop. Those two blokes were after her to get to Quin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Perhaps Quin won’t play ball with them in Moscow without having his daughter with him?” Hyde shook his head vehemently. “Your own source at the Russian embassy gave you quite clear—almost categorical—indications that a snatch squad had stayed overnight, and left again on Aeroflot the day after Quin disappeared. You believed your man then. Why not now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Wait till I see him again. I was led up the garden, taken walkabout if you like. I admit that. But don’t ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("go on believing there’s nothing we can do. Quin dropped out of sight for his own reasons—he could have had a breakdown, for all we know—and the girl’s gone back to him now, or she’s on her way back. I ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("know ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the Russians haven’t got him yet, but they will have as soon as they get their hands on the girl.” Hyde was patting Aubrey’s desk, gently and continuously, to underline his words. He looked at Shelley when he had finished speaking, then asked, “You think they’ve got him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Shelley shrugged. Hyde, understanding his influence with Aubrey, wanted him on his side. Shelley plucked at his bottom lip with thumb and forefinger, then he said, “I don’t know. There’s some room for doubt, I think. It seems too good to be true, after the last few weeks—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I will make the assumption—because it is preferable to do so—that the appearance of the girl means that the KGB have not taken Quin to Moscow, Patrick,” Aubrey said slowly. Hyde exhaled noisily and relaxed in his leather chair. “I still believe that Quin has gone east—” He held up a liver-spotted, wrinkled hand. “Until there is stronger evidence to the contrary. Therefore—” he smiled slightly, “your first task is to contact your helpful but possibly misleading friend at the Soviet embassy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyde nodded. “Today’s pick-up day. He’s not likely to stay away after yesterday, whether he’s straight or crooked.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I suppose we might have to consider him planted, or at least returned?” Aubrey mused.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The abortion was a long time ago. Perhaps he’s back in favour with his bosses,” Hyde suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Ask him. Then find the girl. Simply that. What about her college, for instance?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“CID talked to some of her friends last night. Nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You will go back over the ground. And you will be careful, Patrick, if you are going to begin crossing the path of the gentlemen who were in Sutton Coldfield yesterday. You’d better draw a gun.” He waited for Hyde’s reaction. The Australian nodded after a lengthy pause. “Good. Don’t draw attention to yourself. If your theory is correct, then they might soon begin following you as their best lead to Miss Quin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Anything else?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Aubrey shook his head. “Not for the moment.” Then he added, “This girl?” He tapped a file near his right hand. “Unreliable. Unconventional. Is that your impression?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Her Mum loves her. If she isn’t just a nutcase, then she might be more difficult to find.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I think we’d better find her, don’t you? She’s in danger, whether Quin is in the country or not. They want her, apparently.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“How much time is there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I don’t know. We have ‘Leopard’. It can be manufactured in large numbers, eventually, without Quin. From that point of view, there is a great deal of time. But we are no longer alone. The girl’s time, at least, would seem to be running out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘‘I’ll get on with it, then,” Hyde said, getting up. The leather of the chair squeaked as his frame released it. “Pardon,” he said with a grin. “You can talk about me when I’m gone. I’ll let you know this afternoon what Comrade Vassiliev has to say.” He smiled and left the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Aubrey’s returned smile vanished as soon as the door closed behind Hyde.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What do you think, Peter?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Shelley rounded Aubrey’s desk to face him. Aubrey indicated the Chesterfield, and Shelley sat down, hitching his trousers to preserve their creases as he crossed his long legs. Shelley lit a cigarette, which Aubrey watched with a dry, eager concentration. He had obeyed his physician for more than a year in the matter of smoking. The occasion when the service lift at his flat had not been working for a week, and he had had to walk up three flights of stairs every evening—shortness of breath, body’s fragility indicated to him like a sound blow on his shoulder. No more cigarettes, not even the occasional cigar.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m afraid Patrick’s right, however irritating that may be.” Shelley smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We have been misled—and principally by his source of information at the Soviet embassy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Agreed, sir. But we all accepted Vassiliev after Hyde cleared up the matter of the abortion and the girl in the case was paid off. Vassiliev had walked into our honey-trap, we let Hyde go with him as chief contact. If Vassiliev is forged, then he’s an expert job. Of course, he may just have been trying to please Hyde. The swagman’s not often fooled. That’s why he’s so angry now. I can’t say that I blame him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Shelley exhaled, and Aubrey ostentatiously wafted the smoke away from himself by waving his hand. Shelley appeared not to notice the inconvenience to his superior.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“This incident in Sutton wasn’t an elaborate charade, for our benefit?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I doubt that, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“So do I. The problem is, this ‘Leopard’ business is so damned important. It really is one of those pieces of military technology the Russians haven’t even begun to develop. Or so they tell me at MoD and Zedect. It would put us perhaps years ahead in the anti-submarine warfare game. I really would like to believe that they haven’t got Quin. It just seems too good to be true.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Agreed. But there is such a thing as not looking a gift horse, et cetera, sir—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Perhaps. Another thing that worries me—what price the safety of Comrade Vassiliev? If he fed us duff gen at their orders, then they know Hyde will be coming back now with more questions.” Aubrey shook his head. “I don’t like that idea.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Bruce the Lifeguard can take care of himself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I hope so. Peter, get some Branch people to check around Bracknell again—the avenues we haven’t explored or didn’t give much credence to. Holiday rentings, cottages, that syndrome. People usually run for the hills not the city if they want to hide. I don’t know why that should be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Very well, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And this file—” He tapped Tricia Quin’s folder. “Get all the material out of it for Hyde. A list of people and leads. I have the distinct feeling that very little time is available to us, don’t you?” Aubrey looked up at Shelley as the young man got to his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No comment, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Well?” Lloyd, slumped in his chair, seemed to embrace the small, neat captain’s cabin of the Proteus")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as he opened his hands for an answer. Then, as if drawn by some new and sudden gravity, his hands rested on the chart on his desk. Thurston had brought the chart with him from the control room. He and Carr, the navigator, had marked the course of the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as far as Tanafjord. Thurston sat opposite Lloyd, Carr standing stockily and red-haired behind the first lieutenant, Hayter leaning against the closed door of the cabin. The air conditioning hummed like a sustained note of expectancy. “Well, John? You two? Any comment?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thurston cleared his throat, and in the sidelong movements of his eyes Lloyd saw that these three senior officers had conferred. They were some kind of delegation.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No,” Thurston said at last, “not now we know its position.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Why not?” Lloyd looked up. “You two are in on this, I presume?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Carr said, abruptly, “It makes the whole thing messy, sir. I can’t understand what MoD thinks it’s playing at, ordering us to the mouth of Tanafjord. It smells, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It does, sir,” Hayter confirmed. “A ‘Delta’-class sub in a fjord. Why? What good can it do there? It could loose any missile it wanted to from its berth in Murmansk as well as from that fjord. Why was it there in the first place? Shallow water, no sea room. Sir, we both know it’s a very unlikely beginning to the next war.” Hayter smiled, ingratiating his nerves with his captain.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd rubbed his face, drawing his features into a rubber mask, then releasing the flesh. It assumed a kind of challenged look. Thurston observed Lloyd’s expression with a mild dismay.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re suggesting we disobey a highest priority instruction from the Admiralty?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No. Let’s request confirmation. We could do that—” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We could.” Lloyd looked down at the chart again. “How many hours’ sailing rigged for silent running, taking ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("all ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("precautions?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“A little over thirty-seven,” Carr replied. Hayter looked at him in reproach, as if he had changed allegiance or betrayed a secret. “But I think we should request confirmation, skipper.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Thirty-seven.” Lloyd tapped the chart with his forefinger. “Our course alteration is minimal for the first six hours or more. We’re to continue our work on ‘Chessboard’. For six hours, at least, nothing’s changed.” He smiled. “In that time, we’ll send one signal to MoD, asking for confirmation, and for a fuller definition of our mission status. Does that satisfy you trio of doubting Thomases?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I still don’t like it,” Thurston volunteered.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You were as excited as hell when we picked up the signal from our Russian friend, John. What’s changed?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I used to like watching boxing—it never tempted me to take it up as a hobby.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Don, I want a full tape test and computer check run on ‘Leopard’ as soon as we alter course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’ll get it.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Are we still getting signals from the Russian boat?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thurston nodded. “Sandy’s been monitoring them since we got a reply from MoD.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Carr said, “She’s broadcasting in clear now. Being careful, of course. But the power’s down on the transmission. I think they’re using a low-power emergency back-up set, and they’re altering the frequency with pre-programmed cards. It’s a bloody mess.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Any more details?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No. Codenames, damage indications in some Cyrillic alphabet sequence. Can’t decipher that. The letters and numerals could refer to anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What other traffic?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Murmansk’s been pouring out coded stuff—” Carr shook his head at the light in Lloyd’s eyes. “We don’t have it broken. Code of the day only, frequency-agile transmissions, the lot. But there’s a lot of it. They’re panicking all right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“OK. Sandy, time to fetch "), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Lt. Commander Hackett.” Lloyd nodded at the cabin door, and Hayter moved out of his way as the navigator went in search of the engineering officer. When Hayter closed the door again, Lloyd said, “You don’t really think MoD are wrong on this one, do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thurston pulled a melancholy face. “They aren’t infallible. I think they like the idea of the game, that’s all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’re risking this ship, and ourselves, and ‘Leopard’ on this wild goose chase,” Hayter added with a quiet vehemence. “That doesn’t seem to have struck their lordships. I think the intelligence yield from this ‘monitoring action’ won’t be worth a candle, anyway.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I agree with Don.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd was silent for a time, his hands over his face, the fingers slightly parted as if he were peeping child-like at them or at the chart on his desk. Then he rubbed his eyes and shrugged himself upright in his chair.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’ll ask for confirmation from MoD. Meanwhile, we’ll rig for silent running—and I ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("mean ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("silent from now on.” A grin, unexpected and gleaming, cracked the seriousness of his expression. “It isn’t for real, you two. We won’t be responsible for starting the next war. Nothing is going to happen to us. It’s ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Norwegian, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the Tanafjord. Cheer up. Just look on it as another sea trial.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thurston was about to reply but fell silent as they heard a knock on the cabin door. Lloyd indicated to Hayter that he should open it. The grin was still on Lloyd’s face when Carr ushered Hackett into the cabin. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The wind seemed to follow Hyde into the entrance of Lancaster Gate station, hurrying pages of a copy of the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("New Evening Standard ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ahead of him, with chocolate bar wrappers. He hunched against the wind’s dusty, grubby touch at his neck. He went through the barrier and descended past the framed advertisements to the Central Line eastbound platform. A woman’s legs, gigantic and advertising tights, invited him from the opposite wall. Lunchtime had swelled the numbers of passengers. Hyde lounged against the wall and observed Vassiliev further down the platform. Even here the wind moved the dust in little eddies or thin, gauzy scarves along the platform. Vassiliev wore a dark overcoat across his shoulders, over a pinstriped suit. He looked English enough despite the high Slavic cheekbones and narrow nose, yet he appeared nervous beneath the clothes and the residential veneer England had given him. Hyde was still unsure of him, whether his crime was one of omission or commission.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The train slid into the arched bunker of the platform. Hyde watched Vassiliev board it, then waited until he was the last person still on the platform, then he got into another carriage as the doors shunted together behind him. He stood watching the retreating platform as the train pulled out. Nothing. There was nothing to be learned from nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He and Vassiliev left the train at Tottenham Court Road, Hyde staying twenty yards behind the Russian, closing with him as they transferred to the Northern Line and then getting into the same carriage of the first northbound train. He studied the carriage and its passengers until they pulled into Euston, then took a seat next to Vassiliev. The Russian embassy official, in making a pronounced movement away from him, squeezing himself against the window, suggested either dislike or nerves. Hyde placed his hand on Vassiliev’s arm in a gesture which he knew the man—superficially confident of his heterosexuality but with sexual doubts nagging at him like toothache spoiling good looks and appetite—loathed. The arm jumped beneath his touch.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Now, sport, you and me have some talking to do, don’t we?” Vassiliev looked out of the window. Mornington Crescent. The name slowed and materialised, like oil adopting a mould. “I—I knew you would question me,” he offered.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Too bloody right, mate! You sold me the wrong stuff; Dmitri told me Quin was over on your side. Taken away by the bogeymen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Vassiliev turned at the pressure on his arm and stared at Hyde. Sitting, he was slightly taller than the Australian. His face was thinly imperious for a moment—Hyde, seeing the expression, was strangely chilled—then it subsided quickly into nervousness and apology.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I am not a member of the KGB, you know that. I am not privy to the things they do. What I told you was a fact. I also heard rumours of who their objective was, I passed these on to you. I can do no more.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Vassiliev glanced away from Hyde, into the lightless tunnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I don’t pay you for crap, Dmitri. I don’t blackmail you for rubbish. Now, what do you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Vassiliev shook his arm impatiently, and Hyde released it, thrusting his hand into his pocket and slumping more theatrically in his seat, feet on the seat opposite, to the irritation—silent and frightened—of an elderly man.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I—it is difficult to ask, I can only listen. In the staff restaurant, there is talk of what happened yesterday. I—I am, well, yes, I am almost certain that they are still looking for this Quin—” Hyde listened, every sense aware of the man in the seat next to him. Body temperature coming through the thin sleeve of his windcheater, thigh trembling slightly against Hyde’s own, the faint body odour noticeable above the dusty, greasy smells of the carriage and, the mothball scent from the old man. The voice, grabbing at sincerity, the breathing somehow artificially fast. The words broken by intelligence rather than emotion; thought-out hesitations. “I have not seen the two men—they were low-grade sleepers, I understand, without accreditation to the embassy—” The officialese flowing now like a broad, uninterrupted stream, but not quite because of habit. Learned, Hyde thought; but he remained silent. Quiver gone from Vassiliev’s body. He believed he had acted sufficiently well. “However, there was talk about them, and about the girl—and I’m sure now it is their way of getting to the father—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You picked up a lot yesterday and this morning,” Hyde remarked laconically.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I am ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("trying,” ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Vassiliev pleaded, turning his face to Hyde. Mirror of helpfulness, of urgent sincerity. The eyes expressionless. “I knew what you would want. I was as surprised—shocked—as you must have been. What else can I tell you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Camden Town, slowing down outside the window. Hyde swiftly surveyed the passengers on the platform, those who entered their carriage. He could not believe that they would have let Vassiliev out by himself, without a minder, with such an important role to play. But he could not find his companion. What role was he playing, anyway? Why admit that Quin was still at large?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I want more detail, more information, Dmitri. That’s what you can tell me, and I want it tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I can’t do that!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyde stared into the Russian’s face. “Yes, you can. Oh yes, you can. After all, you’re my creature, I’ve got the arm on you. It’s not the other way round, is it?” Hyde watched the face. Mouth sloping downwards in admission, cheekbones colouring slightly with a sense of shame, brow perspiring in tiny silver beads—ignore, the temperature in the carriage and the overcoat explained it—the eyes quizzical, blank, then striving for the hunted look Hyde expected. Finding, losing, catching and holding it. Vassiliev was playing with him, at the orders of the London Resident or one of his senior staff. Again, he felt momentarily chilled.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes, I will try,” Vassiliev said mournfully.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Highgate. A moment of silence, no one getting on or off the train. Stillness. Then the doors breathing noisily as they closed again. The lights elongating, the words smudged, the darkness of the tunnel, the walls pressing close to the window. Hyde shook off the awareness of himself, the pressing vulnerability. He was being led by the nose, being set up to do their work for them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re sure?” he asked, staring at his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Of what?” Vassiliev asked, momentarily confused. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“He hasn’t been taken over?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The man Quin?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No. No, they do not have him.” East Finchley. Vassiliev began to look uncomfortable, as if he had entered unexplored territory. “They think the girl will lead them to him. I am sure that is what they think.” He looked pleadingly at Hyde.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You were sure they had him three weeks ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I am sure now. Then, I was wrong. There was no ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("talk, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("then. This time, there is gossip.” He was looking over Hyde’s shoulder as the lighted platform slipped away behind them, then he glanced at his watch. “I must get off—I am sure. Mr. Hyde, I am sure this time!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“OK, OK.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Gossip, that is all I bring. You know that. You knew that when you—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("found ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Saved your bloody neck, sport—don’t forget that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Vassiliev blushed with dislike. “I do not forget.” The train was slowing into Finchley Central. Vassiliev was eager to get up. “Where do we meet tonight, what time?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyde hesitated, then: “The club. Eleven.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Good—good. Yes, yes, I will be there—” The train had stopped, the doors had slid back. Hyde, shifting his weight, moved his feet and Vassiliev brushed past him, hopping out of the carriage. He immediately lit a cigarette, but Hyde, looking quickly up and down the carriage and the platform, did not consider it a signal. Then Vassiliev hurried into a patch of windy sunlight towards the southbound platform.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyde watched him disappear, then settled back in his seat, putting his feet up again. The old man still smelt of mothballs. He closed his eyes. The smell of relatives from England coming out to Wollongong, bringing clothes they hadn’t worn for a long time, uncertain of the Australian climate. Big bosoms—Auntie Vi, Auntie Maud, Auntie Ethel—covered by cardigans that smelt of mothballs. He with bare feet and shorts, like an urchin or a schoolboy marooned in Australia. Mothballs. And the voices through his bedroom wall, conveying the magic of England, the rain and snow, the television.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Woodside Park. He bolted upright, eyes wide. His spine was cold. The childhood memories, evoked like a cloud of masking ink, faltered and retreated. He was being played. They would be one step behind, or alongside, every moment of the journey.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Aubrey had not enjoyed Ethan Clark’s narrative. It was too easy, and perhaps correct, to regard it as tales out of school. He had lunched with the American, as a protege of various senior CIA officers of long acquaintance, when Clark had first arrived in London the previous week. At numerous points, he had wanted to protest, request Clark to desist, even to leave. Gradually, however, he had become intrigued, then alarmed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Clark described the “Delta”-class submarine in the Tanafjord, then his voice faltered, and he fell silent. Aubrey, his face gilded by weak sunshine from his office window, sat with his eyes closed and in silence. On an inward screen, he could see Quin’s face, and knew that his mind had forged some obscure yet inescapable link between the man and his invention. A link of mutual danger?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What did Giles Pyott say?” he asked at last. “He didn’t listen—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What did he ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("say?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Clark choked back his anger. “He said,” he began slowly, “that it was none of my damn business and that everyone, including my own Navy Department, agreed with sending ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I can hear him saying it, though not quite in those words,” Aubrey remarked acidly. “Everyone agrees, through to Brussels?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Aubrey sat bolt upright. He appeared unconvinced, even unconcerned, then he said, “You’ve told me about the Russian submarine. Tell me about ‘Chessboard’. That ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("is ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("important?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It is. ‘Chessboard’ could close the Barents to us unless we map it.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And ‘Leopard’. That is of inestimable value, you assess?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“While it’s unique and while the Russians don’t have it, yes.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I agree. But, what if, as we discussed the other day, Quin, its developer, is with the Russians?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Then the sooner we map ‘Chessboard’, and use ‘Leopard’ for everything else we want to know before the Russians develop it themselves, the better.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Then I must tell you, Ethan, that it appears that Quin may not be with the Russians after all. How would that affect your thinking?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Clark was silent with surprise at first, then with concentration. Clouds played shadow-games across Aubrey’s carpet, across the man’s head. Then he said. “It makes all the difference.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You do believe this distress signal is genuine?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It—seems to be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I see. We know the Russians know about ‘Leopard’. They must have had someone inside Zedect at some time. They were interested in acquiring Quin’s services on a permanent basis. They still are. Perhaps they would like ‘Leopard’ instead?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You can’t be serious?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I am merely speculating. Would you say that ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("might be endangered by her new orders?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s closer to the Soviet Union.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Is that why you are so disturbed by all of this?” Aubrey snapped. “Or is it because you don’t like Giles Pyott or the people at the Admiralty?” Aubrey’s face was fierce, even contemptuous.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Look, I came to you in good faith—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You came to me to moan about your lot!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The hell with you, Mr. Aubrey!” Clark made as if to rise.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sit down, Ethan!” Aubrey had turned to his desk again. His hands were calm and unmoving as they rested on its edge. “Sit down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sorry—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Not at all. You came to me because you do feel ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("might be endangered by her new mission. I did not like her sailing orders in the first place. I wanted her kept at sea undergoing trials, or in safe harbour, until the matter of Quin was resolved. I wished ‘Leopard’ removed from ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("until such time as Quin was either recovered or known to be lost to us. I was ignored—overruled. It really isn’t my field, you know.” Aubrey smiled. “The trouble is, MoD is occasionally—and this is one of those occasions—filled with a few too many clots for my liking or reassurance. Giles Pyott is a clever, experienced soldier. He is also a Cavalier rather than a Roundhead. I have always seen myself in the New Model Army rather than Prince Rupert’s cavalry. It always seemed much more sensibly organised, and much safer—” Clark, invited to return Aubrey’s dazzling, self-deprecatory smile, did so. Apparently, he had been tested, and passed. He bore Aubrey no resentment. “My problem is that I find it hard to distinguish between death rays emitting purple light and anti-sonar systems and sonar carpets laid in the Barents Sea. However, we must turn our hand to the work that presents itself.” He studied Clark. “We have one extant ‘Leopard’ system, in one British submarine, engaged upon a task of singular importance. We have one missing scientist. Until the one stray lamb is returned to the fold, I suggest we don’t let the other one loose. Don’t you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What can you do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I wonder. I would like to stop ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Proteus—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I would like to find Quin. Ethan, I trust your judgment. I trust those intuitions that a man like Pyott would not countenance. You have worked in intelligence, he has not. We are all chronically suspicious, perhaps paranoid. However, you and I and the others like us are all we have. Perhaps all ‘Leopard’ has. Hm. Go back to the Admiralty, apologise to Giles Pyott—yes, please—and then keep your eyes and ears open. Ring me tonight—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The intercom’s buzz interrupted him. His secretary announced the arrival of some sandwiches and the imminence of a pot of coffee. Aubrey ordered her in. Before the door opened, Clark said swiftly, “What can you do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I don’t know, Ethan. Unfortunately, I shall have to do something, or else I shall begin sleeping badly at night. Ah, coffee and sandwiches, splendid!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ve got her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“When?” Dolohov asked as Sergei closed the door of the Ops. Room behind him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Only minutes ago. The satellite’s had terrible trouble with the cloud cover—”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Show me. Admiral—” Dolohov nodded to the Ops. Room commander, then almost snatched the folded chart overlain with its sheet of developed infra-red film. Poor, pale smudges, like smeared rust or very old blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“The pattern’s changed, as you can see.” Sergei was leaning over Dolohov’s shoulder. His finger tapped the sheet over the chart. “This was her three hours ago—same intermittent smudges, her mapping course, enough for us to tell she was still following the same search pattern. Then here we think there was another trace—” The smear was almost invisible. Dolohov did not move the chart closer to his face. “Then nothing for two hours, then this—then another fifty-four minutes before we got this.” It was like the last ember of a dying fire. It was out of the random yet sequential pattern, and it had moved south and east of the other smears.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re certain?” Dolohov was looking at the rear admiral. “We’ve used sonar in that area, and we got nothing. If it is a submarine, then it is the British ship.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Excellent! It works, how well it works, mm?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Too well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Come, Admiral—no sour grapes. You have a computer prediction on speed and course?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We have one, based on the last three traces. We need at least two more to be at all accurate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Show me, man, show me!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("One of the rear admiral’s aides scuttled into the control room. Dolohov leaned over the rail of the gantry. As he watched, the rear admiral joined him. Then a curving line appeared on the projection below, from a position far out in the Barents Sea, making south and east towards the Tanafjord. It rendezvoused with the imaginary Soviet submarine trapped in the fjord.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“In excess of thirty hours,” the rear admiral murmured, “and no longer than thirty-six. That’s the best we can do without another infra-red fix from the satellite. For the moment, she’s disappeared again. Possibly cloud again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Good man,” Dolohov said incongruously. He gripped the rear admiral’s shoulder. The man was considerably younger than himself, bespectacled and clerkish. A computer expert, perhaps, an academic; scientist rather than sailor. Nevertheless, at that moment Dolohov felt an unaccustomed affinity with the man. “Good man.” He turned to Sergei. “Call Leningrad. Whether they’re at the Grechko Academy or the Frunze Naval School, I want Ardenyev and his team informed at once. They will depart for Murmansk immediately.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dolohov turned back to the rear admiral. “Keep up the good work. If the Red Banner Special Underwater Operations Unit does its job as well as you are doing yours, then nothing can go wrong!” He laughed throatily. “Excellent, excellent! I don’t care what success the KGB has now in finding the man Quin—we will be able to present Moscow with Quin’s toy. The man himself will have no value, and ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("we ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shall enjoy the sunshine. Excellent, excellent!” His continued laughter caused one of the map table operators to look up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The strip club was a short walk from Oxford Street, hunched in a narrow side street on the edge of Soho, as if aspiring to membership of that district, or recently expelled from it. Hyde had used it as a meeting place with Vassiliev because clubs of its type attracted the diplomats and officials of East European embassies, especially early on in their tours of duty, and even if Vassiliev had been under surveillance by his own people, such visits would have been regarded as misdemeanours rather than as suspicious or dangerous.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyde glanced at the membership ledger, having bribed the doorman. One or two new members that evening, but it told him nothing. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They might be Vassiliev’s friends, or football fans or businessmen staying overnight in London. Vassiliev’s friends would have ensured their membership sometime earlier, if this was an entrapment exercise. Hyde did not consider it was. They wanted him running, moving with apparent freedom. He went down the steps beneath a dim green undersea light, the mingled odour of sweat, smoke and tawdriness coming up to meet him. The door opened to admit him—he had heard the buzzer sound from the doorman’s cubicle as he began his descent. Disco music thumped against his ears, flat, enervating, unmemorable. Strobe lights played over the heads of the audience. The tiny stage was empty, but there was a narrow bed lit by a silvery, ghostly light at the back of it. Hyde remained by the door. The large man with cropped hair wearing an out-of-style dinner jacket loomed at his shoulder. Hyde suspected he knew his profession and did not confuse him with the Vice Squad or CID. At worst, he would assume him to be Security rather than Intelligence. It did not matter. Rather, it legitimised the club, provided a governmental patron.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There were only a small number of people waiting for the next bout on the stage. Vassiliev—he saw as his eyes accustomed themselves to the peculiar, winking gloom—was in a corner, near the stage, mournfully staring into a glass. There seemed no one who had noticed, or become concerned at, his entrance. He threaded his way between the tables with their grubby cloths and expensive drinks towards Vassiliev. The Russian seemed relieved to see him. If there were other emotions, conflicting ones, then the strobe flicker hid them. Hyde settled in a chair which faced the door, and immediately a waiter appeared at his side. No girls on the floor of the club, no hostesses. A curious puritanism pervaded the place. Untouchable, flaunting, indescribably crude, silicon-enhanced, the women came and went on the stage, separate and inviolable.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Near them, the pianist resumed his seat. The drummer rolled softly, as if communicating with his drums. A bass player leaned tiredly over the neck and shoulders of his instrument. All of them appeared to be awaiting some summons to Ronnie’s in Frith Street, two blocks away. Most of the girls stripped to records, anyway. Hyde ordered a beer. It came in a half-pint glass, and there was no change from his pound note. He clicked his tongue and winked at the waiter.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyde sipped at his drink. The trio drew attention to the stage with a peremptory call to attention that echoed Oscar Peterson. then slipped into the straitjacket of “I’m Forever Blowing Bubbles” as a bath was wheeled on.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Oh, Christ—bath night again,” Hyde murmured. “Ivy the Terrible.” The subdued chatter of the audience tailed off into a silence that was weary rather than expectant. “Well, Dmitri?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Vassiliev leaned towards him, eyes flicking over Hyde’s shoulder towards the stage, as the pianist imitated a fanfare. Hyde could never decide whether Vassiliev’s interest in the girls was genuinely naive and crude, or merely a badge of his manhood, designed to be noticed by those in his company. The KGB regarded homosexuals in only one light—as victims: malleable, male prostitutes. If Vassiliev had any hidden proclivities towards men, then he was wise to hide them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You were wrong,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was the one statement Hyde had not expected to hear. It generated a mass of complex doubts, questions and fears in an instant. The woman on stage was young, breasts extended to unnatural size by injection and implant, face expressionless beneath the make-up. See-through negligée, towel and loofah, bar of soap. The trio vamped the only expectancy in the now darkened room. Hyde watched the stage, picking his way towards the appropriate degree of innocent surprise. “Dmitri, what do you mean I was wrong?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“They ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("have ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("got Quin. They have him, but they want the girl.” Vassiliev’s sweat gave off the pungency of the body rub he used. It clashed with his after shave, with the girl’s scent, the omnipresent cigarette smoke.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m not wrong,” Hyde began, but Vassiliev was already nodding eagerly. Hyde felt cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes. Look, I risked everything this afternoon. There was no more gossip. I looked in the travel ledger. I went back and checked on the people who came in. They left with a third man the next day. They flew to Paris in a light aircraft. I have the address, the booking. Three passengers—” He reached into his pocket, but Hyde grabbed his hand. It quivered in his grip, which was slippery against Vassiliev’s skin, informing Hyde that his nerves were taking him over. The girl was testing the supposed temperature of the water in the bath, letting the negligée fall open almost to the crutch. None of the audience was watching their corner of the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Three? Three? What proof’s that? I don’t believe you, Dmitri. I don’t think you know,” Hyde hissed at the Russian, still gripping the man’s hand near his chest. The girl had stepped—with something less than elegance—over the side of the bath. Her negligée was drooping from one shoulder, tented by one enormous breast.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You must believe me, you must!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I don’t, Dmitri. Now, what bloody game are you playing?” The girl was obviously going to bath with tassels on her nipples. She slid down into the supposed water. Then Vassiliev’s eyes began moving, darting round the room. Hyde forced himself not to turn round. It did not mean there was someone in the room, only that there were others, either nearby or simply giving orders. Hyde gripped his thigh with his free hand, forcing the calm of angered puzzlement into his frame and face and voice. “What bloody game are you playing, mate?” The girl had divested herself of the negligée, but not the tassels. She was stroking herself with the loofah.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No game, Mr. Hyde, no game!” Vassiliev was leaning towards him like a lover in the hot darkness, but he could not keep his eyes on Hyde’s face. Escape, help, answers. He repeated the formula they had taught him. “Three men left in that plane for Paris. Yes, they want the girl, but they have Quin in Moscow—I’m certain of it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You don’t know who the third man was. It couldn’t have been Quin—” Hyde found himself engaged in an attempt to justify the suspicions he had voiced to Aubrey, as if he believed Vassiliev. The girl was on the point of engaging in intercourse with the loofah. Soon she would be dropping the soap. “No,” he said, “you’re lying, Dmitri. Why should they want you to lie?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“They? What do you mean?” Too innocent.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You weren’t lying or mistaken at lunchtime. You ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("knew, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("then. Now, you’re working for them. Did they ask you how much you told me? Did they?” Hyde’s face was close to Vassiliev. He could smell the man’s last meal on his breath, and the brandy after dinner. Too much brandy—no, they wouldn’t have allowed him more than one or two. “They knew about you all the time, but they didn’t let on. Not until they realised you must have told me more than was good for me.” He was shaking Vassiliev’s hand, in anger and in community. The girl had dropped the soap, which did not slide across the stage. Her enormous breasts were hung over the side of the bath as she attempted to retrieve it. The trio was playing palm court music. The prissy, virginal sweetness of it assailed Hyde. “You were doing all right until you told me you thought they didn’t have Quin. And you ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("know ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it!” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I—must go,” Vassiliev said. Now the soap was back in the bath but lost again. The girl was looking for it on her hands and knees.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Snake-charmer music, and she rose to her feet, backside to the audience, buttocks proffered, swaying.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re going nowhere. Where are they?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Not here, not here!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re coming in, Dmitri.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You have to. We’ll take care of you. I can’t behave as if I believe you. You’re the one in danger now.” Vassiliev had thought of it but had ignored it. He shook his head, as if the idea was only a pain that would move, dissipate. The girl had the loofah again, standing up now, in profile to the room. The loofah was being energetically applied. “Come on,” Hyde added.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No! I can’t leave with you, I can’t!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Why not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I can’t!” He was pleading now. They were outside. If he emerged with Hyde, they would know Hyde had not swallowed the tale. The almost religious silence of the room was broken by hoarse cries of encouragement, underscored with what seemed like a communal giggle. The girl’s body acknowledged the response to her performance.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You can!” The gun, the gun—he’d left it at his flat, held it in his hand, almost amused, for a moment before stuffing it under a pile of shirts in a drawer. The gun—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“No, no, no—” Vassiliev was shaking his head vehemently. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s your only chance. Come on, the back way.” Hyde got up, stood over the Russian, willing him to his feet. Vassiliev rose, and they shuffled through the tables towards the toilets. The door into the concrete, ill-lit corridor sighed shut behind them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Vassiliev immediately turned to him. “No,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“They concocted this story, right?” Vassiliev nodded, nerveless, directionless now. “Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I don’t know. They told me they had known that they had fed you the information about Quin through me, deliberately. Then yesterday happened, and while they were deciding what to do about me, we talked. I told them everything.” A sense of shame, as sharp as a physical pain, crossed his features.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s all right, it’s all right—was there anyone in the club?” Vassiliev shook his head. There was applause on the other side of the door. “Come on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyde half-pushed Vassiliev towards the emergency exit beyond the toilet. He heaved at the bar, remembered letting in friends by similar doors in Wollongong cinemas just before the start of the main feature, then the door swung open. The windy night cried in the lightless alley. He paused momentarily and looked at Vassiliev. Then he nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They went through the door almost together, but even so the man with the gun must have been able to distinguish between them. Vassiliev cried out—Hyde hardly heard the brief plopping sound of the silenced gun before the Russian’s murmured cry—then he slumped against Hyde, dragging at his clothes, smearing the front of the Australian’s shirt with something dark and sticky. Then he fell back, for a moment his face green from the exit sign’s light, then all of him was simply a barely distinguishable bundle of clothes on the other side of the alley. Hyde waited for the noise of footsteps above the wind’s dry call, or the sound of another stone-into-water plop that would be the last sound he would ever hear.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c869ebae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SeaLeopard5.vue
// module id = 87
// module chunks = 0